export type ContentStatus =
  | "idea" | "research" | "brief" | "draft"
  | "human_review" | "seo_review" | "ready" | "published" | "refresh_needed";

export const STATUS_ORDER: ContentStatus[] = [
  "idea", "research", "brief", "draft", "human_review", "seo_review", "ready", "published", "refresh_needed",
];

export const STATUS_META: Record<ContentStatus, { label: string; color: string; bg: string }> = {
  idea:           { label: "Idea",           color: "hsl(0 0% 60%)",   bg: "hsl(0 0% 12%)" },
  research:       { label: "Research",       color: "hsl(207 68% 65%)", bg: "hsl(207 68% 50% / 0.10)" },
  brief:          { label: "Brief",          color: "hsl(265 70% 70%)", bg: "hsl(265 70% 55% / 0.10)" },
  draft:          { label: "Draft",          color: "hsl(38 92% 65%)",  bg: "hsl(38 92% 55% / 0.10)" },
  human_review:   { label: "Human Review",   color: "hsl(28 92% 65%)",  bg: "hsl(28 92% 55% / 0.10)" },
  seo_review:     { label: "SEO Review",     color: "hsl(180 70% 60%)", bg: "hsl(180 70% 45% / 0.10)" },
  ready:          { label: "Ready",          color: "hsl(142 70% 55%)", bg: "hsl(142 70% 45% / 0.10)" },
  published:      { label: "Published",      color: "hsl(142 50% 50%)", bg: "hsl(142 50% 35% / 0.12)" },
  refresh_needed: { label: "Refresh Needed", color: "hsl(0 75% 65%)",   bg: "hsl(0 75% 55% / 0.10)" },
};

export const PIPELINE_COLUMNS: ContentStatus[] = [
  "idea", "research", "brief", "draft", "human_review", "seo_review", "ready", "published",
];

export function nextStatus(s: ContentStatus): ContentStatus | null {
  const i = STATUS_ORDER.indexOf(s);
  return i >= 0 && i < STATUS_ORDER.length - 2 ? STATUS_ORDER[i + 1] : null; // stop at "published"
}
